export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valuta"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea report"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Risultato valuta"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scaricare"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Foglio"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formato file consentito - xlsx"])}
}